module.exports = __webpack_public_path__ + "static/media/icon-hosts.82b049de.svg";